import axios, { AxiosResponse } from "axios";
import { auth } from "../context/AppContext";

//export const SERVER_URL = "http://localhost:4000";
export const SERVER_URL = "https://ipwd-server.uc.r.appspot.com";

export async function sendAxiosPost(endpoint: string, data?: any, includeFirebaseToken?: boolean): Promise<any> {
    try {
        let body = data;
        if (includeFirebaseToken) {
            const token = await auth.currentUser?.getIdToken(true);
            if (!token) {
                console.error("No user logged in");
                return null;
            }
            body = { token: token, ...data };
        }
        const response = await axios.post(`${SERVER_URL}${endpoint}`, body);
        return response.data;
    }
    catch (error:any) {
        return { success: false, error: error.message };
    }
}